var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"workflow-configs",class:{ loading: _vm.loading, ready: !_vm.loading }},[_c('dd',[(_vm.processVariable)?_c('data-viewer',{staticClass:"configs-container",attrs:{"item":_vm.processVariable,"title":_vm.$t('dj-运行参数')}}):_c('div',{staticClass:"no-data"},[_vm._v(_vm._s(_vm.$t("dj-暂无数据")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }